import { render } from "./TasksWrapper.vue?vue&type=template&id=748918ba&scoped=true&ts=true"
import script from "./TasksWrapper.vue?vue&type=script&lang=ts"
export * from "./TasksWrapper.vue?vue&type=script&lang=ts"

import "./TasksWrapper.vue?vue&type=style&index=0&id=748918ba&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-748918ba"]])

export default __exports__